<template>
  <template v-if="theOnlyOneChild">
    <el-menu-item :index="resolvePath(theOnlyOneChild?.path)" :class="{ 'submenu-title-noDropdown': isFirstLevel }">
      <template v-if="isFirstLevel">
        <svg v-if="theOnlyOneChild.meta?.icon" class="menu-icon" aria-hidden="true">
          <use :xlink:href="theOnlyOneChild.meta?.icon"></use>
        </svg>
        <el-icon v-else :size="20"><Menu /></el-icon>
      </template>

      <template #title>
        <span>{{ theOnlyOneChild.meta?.title }}</span>
      </template>
    </el-menu-item>
  </template>

  <el-sub-menu v-else :index="resolvePath(item.path)">
    <!-- popper-append-to-body -->
    <template #title>
      <template v-if="isFirstLevel">
        <svg v-if="item.meta?.icon" class="menu-icon" aria-hidden="true">
          <use :xlink:href="item.meta?.icon"></use>
        </svg>
        <el-icon v-else :size="20"><Menu /></el-icon>
      </template>

      <span
        v-if="item.meta?.title && (!isCollapse || !isFirstLevel)"
        :class="{
          'sub-list-title': !isFirstLevel && !isCollapse
        }"
      >
        {{ item.meta.title }}
      </span>
    </template>

    <SideBarItem
      v-for="child in item.children"
      :key="child.path"
      :item="child"
      :base-path="child.path"
      :is-collapse="isCollapse"
    />
  </el-sub-menu>
</template>

<script>
// 递归组件要命名
export default {
  name: 'SideBarItem'
}
</script>

<script setup>
import { Menu } from '@element-plus/icons-vue'
import path from 'path'
import { isExternal } from '@shared/utils/validate'
import useAppStore from '@shared/store/useAppStore'

const route = useRoute()

const props = defineProps({
  item: { type: Object, required: true },
  isCollapse: {
    type: Boolean,
    required: false
  },
  isFirstLevel: {
    type: Boolean,
    default: false
  },
  basePath: {
    type: String,
    default: ''
  }
})

const appStore = useAppStore()

/** 显示的子菜单数量 */
const showingChildNumber = computed(() => {
  if (props.item.children) {
    const showingChildren = props.item.children.filter((item) => !item.meta?.hidden)
    return showingChildren.length
  }
  return 0
})

/**
 * 渲染单个子项判断
 * 1，没有设置meta?.title 并且只有一个子项
 * 2，没有children
 */
const theOnlyOneChild = computed(() => {
  // 有设置title或者有多个子项的，渲染下拉框
  if (showingChildNumber.value > 1 || (showingChildNumber.value === 1 && props.item.meta?.title)) {
    return null
  }
  // 没有title，并且只有一个子菜单
  if (props.item.children) {
    for (const child of props.item.children) {
      if (!child.meta?.hidden) {
        return child
      }
    }
  }

  return { ...props.item, path: '' }
})

const resolvePath = (routePath = '') => {
  if (isExternal(routePath)) {
    return routePath
  }
  if (isExternal(props.basePath)) {
    return props.basePath
  }
  return path.resolve(props.basePath, routePath)
}

// 判断当前菜单项是否为激活状态
const isActive = computed(() => {
  const currentPath = resolvePath(theOnlyOneChild.value?.path || props.item.path)
  // 匹配当前路由路径或路由meta中配置的activeMenu
  return route.path === currentPath || route.meta.activeMenu === currentPath
})
</script>

<style lang="scss" scoped>
:deep() {
  .menu-icon {
    width: 18px;
    height: 18px;
    line-height: 18px;
    margin-right: 8px;
  }

  .sub-list-title {
    padding-left: 0;
  }
}
</style>
